import styled from 'styled-components';
export const LargeCardBase = styled.div.attrs({
    className: 'card card-large',
}) `
  display: flex;
  flex-direction: column;

  width: 100%;
  box-sizing: border-box;

  font-size: 16px;
  line-height: 24px;

  border: 3px solid var(--color-surface-border);
`;
export const Graphic = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;

  & > .icon {
    margin: 24px 0;
    width: 96px;
    height: 96px;

    > svg {
      height: 100%;
      width: 100%;
    }
  }

  & > img {
    height: 144px;
    width: 100%;
    object-fit: cover;
  }
`;
export const Content = styled.div `
  flex: 1;

  padding: 24px 24px 16px 24px;
`;
export const Title = styled.div `
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;
export const Caption = styled.div `
  font-size: 14px;
`;
export const Overline = styled(Caption) ``;
export const Description = styled.div `
  padding-top: 16px;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;
export const Actions = styled.div `
  display: flex;

  padding: 12px 0px;

  & > a > i {
    transition: transform 0.1s ease-in;
  }

  & > a:hover {
    background: var(--color-background);
    & > i {
      transform: translateX(4px);
    }
  }

  & > a + a {
    margin-left: 8px;
  }
`;
export const MediumCardBase = styled.a.attrs({
    className: 'card card-medium',
}) `
  display: flex;
  align-items: center;

  width: 100%;

  color: var(--color-on-surface);
  text-decoration: none;

  padding: 16px;
  height: 80px;
  box-sizing: border-box;
  border: 3px solid var(--color-surface-border);

  & > ${Title} {
    flex: 1;
  }

  & > i {
    font-size: 16px;
    line-height: 16px;
    color: var(--color-primary);
    margin-left: 16px;
  }
`;
export const MediumGraphic = styled.div `
  margin-right: 16px;
  width: 48px;
  height: 48px;

  & > .icon {
    width: 48px;
    height: 48px;

    > svg {
      height: 100%;
      width: 100%;
    }
  }
`;
